/** `AAAA-MM-JJ` → `JJ/MM/AAAA`. */
export function jourLisible(iso: string): string {
  const [annee, mois, jour] = iso.slice(0, 10).split('-');
  return `${jour}/${mois}/${annee}`;
}

/** Instant ISO → « 16/10/2026 à 06:00 », heure de La Réunion. */
export function instantLisible(iso: string): string {
  const instant = new Date(iso);
  const jour = instant.toLocaleDateString('fr-FR', { timeZone: 'Indian/Reunion' });
  const heure = instant.toLocaleTimeString('fr-FR', {
    timeZone: 'Indian/Reunion',
    hour: '2-digit',
    minute: '2-digit',
  });
  return `${jour} à ${heure}`;
}

export const CLASSE_CHAMP =
  'min-h-[44px] w-full rounded-xl border border-gray-200 bg-gray-50 px-3 text-sm text-codialis-navy';
export const CLASSE_ZONE_TEXTE =
  'w-full rounded-xl border border-gray-200 bg-gray-50 px-3 py-2.5 text-sm text-codialis-navy';
export const CLASSE_LIBELLE =
  'mb-1 block text-[11px] font-bold uppercase tracking-wide text-codialis-navy';
